"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zipObjValue = exports.memoizeWith = exports.isNotNilAndNotEmpty = exports.isNotNil = exports.isNotEmpty = exports.concatAndUniq = void 0;
const R = __importStar(require("ramda"));
const concatAndUniq = (...arrays) => R.uniq(arrays.flat());
exports.concatAndUniq = concatAndUniq;
const zipObjValue = (value) => (keys) => {
    return R.reduce((currentObject, key) => (Object.assign(Object.assign({}, currentObject), { [key]: value })), {}, keys);
};
exports.zipObjValue = zipObjValue;
const isNotNil = R.complement(R.isNil);
exports.isNotNil = isNotNil;
const isNotEmpty = R.complement(R.isEmpty);
exports.isNotEmpty = isNotEmpty;
const isNotNilAndNotEmpty = R.allPass([isNotNil, isNotEmpty]);
exports.isNotNilAndNotEmpty = isNotNilAndNotEmpty;
/**
 * This is a re-implementation of Ramda's memoizeWith method
 * but using a Map instead of a plain object to limit memory usage
 */
const memoizeWith = R.curryN(2, (generateKey, memoizedFn) => {
    const cache = new Map();
    let cacheSize = 0;
    return (...args) => {
        const key = generateKey(...args);
        if (!cache.has(key)) {
            cache.set(key, memoizedFn(...args));
            if (cacheSize < 300000) {
                cacheSize++;
            }
            else {
                const firstElementKey = cache.keys().next().value;
                cache.delete(firstElementKey);
            }
        }
        return cache.get(key);
    };
});
exports.memoizeWith = memoizeWith;
